const LangSidebar = {
	"sidebar.navigation._account": ["ACCOUNT SUMMARY", "TÓM TẮT TÀI KHOẢN"],
	"sidebar.navigation._rewards": ["MY REWARDS", "QUÀ THƯỞNG CỦA TÔI"],
	"sidebar.navigation._profile": ["MY PROFILE", "TÀI KHOẢN CỦA TÔI"],
	"sidebar.navigation._cards": ["MY CARDS", "THẺ CỦA TÔI"],
	"sidebar.navigation._egift": ["E-GIFT", "Quà TẶNG ĐIỆN TỬ"],
	"sidebar.navigation._transactions": ["TRANSACTION HISTORY", "LỊCH SỬ GIAO DỊCH"],
	"sidebar.navigation._contactUs": ["CONTACT US", "LIÊN HỆ CHÚNG TÔI NGAY"],
	"sidebar.navigation._logout": ["SIGN OUT", "ĐĂNG XUẤT"],
	"sidebar.navigation._unregister": ["UNREGISTER", "HỦY TÀI KHOẢN"],
	"sidebar.navigation._downloadMobile": [
		"DOWNLOAD MOBILE APP",
		"TẢI ỨNG DỤNG ĐIỆN THOẠI",
	],
	"sidebar.navigation._havingDifficulties": [
		"HAVING DIFFICULTIES? ",
		"BẠN CẦN GIÚP ĐỠ?",
	],
	"sidebar.navigation._contact": ["CONTACT", "LIÊN HỆ"],
	"sidebar.navigation._contactCsv": ["OUR CUSTOMER SERIVCE NOW", "CHÚNG TÔI NGAY"],
}

export default LangSidebar



// WEBPACK FOOTER //
// ./src/resources/modules/LangSidebar.js